/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maca_MinimizeInputs */

const en_maca_minimize = /** @type {(inputs: Maca_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimize`)
};

const ar_maca_minimize = /** @type {(inputs: Maca_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصغير`)
};

const bn_maca_minimize = /** @type {(inputs: Maca_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মিনিমাইজ করুন`)
};

const de_maca_minimize = /** @type {(inputs: Maca_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimieren`)
};

const es_maca_minimize = /** @type {(inputs: Maca_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimizar`)
};

const fr_maca_minimize = /** @type {(inputs: Maca_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réduire`)
};

const pt_maca_minimize = /** @type {(inputs: Maca_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimizar`)
};

const zh_maca_minimize = /** @type {(inputs: Maca_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小化`)
};

const tr_maca_minimize = /** @type {(inputs: Maca_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Küçült`)
};

const ru_maca_minimize = /** @type {(inputs: Maca_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свернуть`)
};

const pl_maca_minimize = /** @type {(inputs: Maca_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalizuj`)
};

/**
* | output |
* | --- |
* | "Minimize" |
*
* @param {Maca_MinimizeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const maca_minimize = /** @type {((inputs?: Maca_MinimizeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maca_MinimizeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_maca_minimize(inputs)
	if (locale === "bn") return bn_maca_minimize(inputs)
	if (locale === "de") return de_maca_minimize(inputs)
	if (locale === "es") return es_maca_minimize(inputs)
	if (locale === "fr") return fr_maca_minimize(inputs)
	if (locale === "pt") return pt_maca_minimize(inputs)
	if (locale === "zh") return zh_maca_minimize(inputs)
	if (locale === "tr") return tr_maca_minimize(inputs)
	if (locale === "ru") return ru_maca_minimize(inputs)
	if (locale === "pl") return pl_maca_minimize(inputs)
	return en_maca_minimize(inputs)
});